import { CurrencyCode } from './currencyUtils'

export { CurrencyCode } from './currencyUtils'

// TODO: add currency symbols for all the supported codes
const currencySymbolMap: Partial<Record<CurrencyCode, string>> = {
  EUR: '€',
  USD: '$',
  AED: 'د.إ',
  AFN: '؋',
  AUD: '$',
  AZN: '₼',
  BDT: '৳',
  BGN: 'лв',
  BHD: '.د.ب',
  BND: '$',
  BTC: '฿',
  CAD: '$',
  CHF: 'CHF',
  CNY: '¥',
  CRC: '₡',
  CUP: '₱',
  CZK: 'Kč',
  DKK: 'kr',
  DZD: 'دج',
  EGP: '£',
  FJD: '$',
  GBP: '£',
  GEL: '₾',
  HKD: 'HK$',
  HRK: 'kn',
  HUF: 'Ft',
  IDR: 'Rp',
  ILS: '₪',
  INR: '₹',
  IQD: 'ع.د',
  IRR: '﷼',
  ISK: 'kr',
  JOD: 'JD',
  JPY: '¥',
  KGS: 'лв',
  KHR: '៛',
  KRW: '₩',
  KWD: 'KD',
  LKR: '₨',
  LTL: 'Lt',
  LVL: 'Ls',
  MAD: 'MAD',
  MNT: '₮',
  MXN: '$',
  MYR: 'RM',
  NAD: '$',
  NGN: '₦',
  NPR: '₨',
  NZD: '$',
  OMR: '﷼',
  PGK: 'K',
  PHP: '₱',
  PKR: '₨',
  PLN: 'zł',
  QAR: '﷼',
  RON: 'lei',
  RUB: '₽',
  SAR: '﷼',
  SDG: 'ج.س.',
  SEK: 'kr',
  SGD: '$',
  STD: 'Db',
  THB: '฿',
  TRL: '₤',
  TRY: '₺',
  UAH: '₴',
  VND: '₫',
  XBT: 'Ƀ',
  XPF: '₣',
}

export const getCurrencySymbol = (currencyCode: CurrencyCode): string => currencySymbolMap[currencyCode] || currencyCode
const getRoundOffCurrency = (c: ICurrency): string => {
  return Number(c.value).toFixed(2)
}
export const formatCurrency = (c: ICurrency): string => {
  if (c.value == null) {
    // eslint-disable-next-line no-param-reassign
    c.value = 0
    // eslint-disable-next-line no-param-reassign
    c.code = 'EUR'
  }
  return `${getCurrencySymbol(c.code)} ${getRoundOffCurrency(c)}`
}

export interface ICurrency {
  value: number | string
  code: CurrencyCode
}
